'use client'

import { Calendar } from 'react-feather'
import { ConsultationCard } from '@/entities/consultation'
import { GetMyInfosQuery } from '@/core/graphql/types'
import { useRouter, useTranslations } from '@/lib/next-shim'
import { ConsultationsFilterTabs, ConsultationsFilterTabValue } from './ConsultationsFilterTabs'

type Consultation = GetMyInfosQuery['myInfos']['consultations'][number]

type ConsultationsClientProps = {
  consultations: Consultation[]
  tab: ConsultationsFilterTabValue
  error?: string
}

export function ConsultationsList({ consultations, tab, error }: ConsultationsClientProps) {
  const t = useTranslations()
  const router = useRouter()

  if (error) {
    return <div className="rounded-lg bg-red-50 p-4 text-red-600">{error}</div>
  }

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2.5">
          <h2 className="section-title">{t('account.sections.Consultations.title')}</h2>
          {!!consultations.length && (
            <span className="rounded-full bg-primary/10 px-2 py-0.5 text-xs font-semibold tabular-nums text-primary">{consultations.length}</span>
          )}
        </div>
        <ConsultationsFilterTabs defaultTab={tab} />
      </div>

      <section>
        {consultations.length ? (
          <div className="flex flex-wrap justify-center gap-4 sm:gap-5">
            {consultations.map((consultation) => (
              <ConsultationCard key={consultation._id} consultation={consultation} onClick={() => router.push(`/account/consultations/${consultation._id}`)} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-gray-200 bg-white px-6 py-12 text-center">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
              <Calendar size={22} aria-hidden="true" />
            </span>
            <p className="text-sm font-semibold text-gray-900">{t('account.sections.Consultations.empty')}</p>
            <p className="max-w-xs text-sm text-gray-500">{t('account.sections.Consultations.emptyHint')}</p>
          </div>
        )}
      </section>
    </div>
  )
}
